import { useAccount } from "wagmi";

export const useAccountInfo = () => {
  const account = useAccount();
  const connectedAddress = account?.address;

  // Ensure connectedAddress is a string before slicing
  const shortenedAddress =
    typeof connectedAddress === "string"
      ? `${connectedAddress.slice(0, 6)}...${connectedAddress.slice(-4)}`
      : "";

  return { fullAddress: connectedAddress, shortenedAddress, account };
};
